import {
  PromptModelWorkflow as ServerPromptModelWorkflow,
  TableValue,
} from '~/api/sylvanus/typedefs.autogen';
import { PromptModelWorkflow } from '~/features/x-ray/debug/types';
import { FieldValueBase } from '~/features/x-ray/fields/types';
import { sylvanus } from '~/services/serviceInstances';
import { Nullable } from '~/types/Nullable';
import { Uuid } from '~/types/Uuid';

import { mapTableValue, mapValue } from './transformers';

interface Request {
  highlightMethod: string;
  modelId: Uuid;
  cursor?: string;
  filters?: string[];
}

type Response = { cursor: Nullable<string>; items: PromptModelWorkflow[] };

export const getPromptModelWorkflowPredictions = async ({
  cursor,
  filters,
  highlightMethod,
  modelId,
}: Request): Promise<Response> => {
  const filterParams = (filters ?? [])
    .map((filter) => `&status=${filter}`)
    .join('');
  const base = `/model/${modelId}/predict?page_size=100${filterParams}`;
  const endpoint = cursor ? `${base}&cursor=${cursor}` : base;
  const response = await sylvanus.get(endpoint);

  return {
    cursor: response.cursor,
    items: response.items.map((item: ServerPromptModelWorkflow) => {
      const isTableModel = item.output?.value_type === 'table_value';
      return {
        ...item,
        output: item.output
          ? {
              ...item.output,
              ...(isTableModel
                ? mapTableValue(item.output as Nullable<TableValue>)
                : mapValue(
                    item.output as Nullable<FieldValueBase>,
                    highlightMethod,
                  )),
            }
          : null,
      };
    }),
  };
};
